// Angular Imports
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
// Shared Imports
import { NotfoundComponent } from '@shared/components'
import { ERoles } from '@shared/models'
import { isLoggedGuard, hasRolesGuard } from '@shared/guards'

const routes: Routes = [
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full',
	},
	{
		path: 'dashboard',
		loadChildren: () =>
			import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
		canLoad: [isLoggedGuard],
		canActivate: [isLoggedGuard, hasRolesGuard],
		data: {
			allowedRoles: [ERoles.viewer, ERoles.administrator],
		},
	},
	{
		path: '**',
		component: NotfoundComponent,
		data: {
			returnBack: false,
			redirectTo: 'dashboard',
		},
	},
]

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
